import Vue from 'vue';
import Auth from '@js/plugins/auth';
import Unleash from '@js/plugins/unleash';

Vue.component('vuetable-daily-sales', () =>
    import(/* webpackChunkName: 'daily-sales-index' */ './vuetable-daily-sales.vue'),
);

Vue.component('vuetable-till-closure', () =>
    import(/* webpackChunkName: 'card-sales-show' */ './vuetable-till-closure.vue'),
);

if (Unleash.hasFeature('ljh_report')) {
    Vue.component('show-daily-sales', () =>
        import(/* webpackChunkName: 'daily-sales-show' */ './show-daily-sales-v2.vue'),
    );
} else {
    Vue.component('show-daily-sales', () =>
        import(/* webpackChunkName: 'daily-sales-show' */ './show-daily-sales.vue'),
    );
}

Vue.component('show-card-sales', () =>
    import(/* webpackChunkName: 'card-sales-show' */ './show-card-sales.vue'),
);

Vue.component('show-card-sales-old', () =>
    import(/* webpackChunkName: 'card-sales-show' */ './show-card-sales-old.vue'),
);

Vue.component('show-card-edc-sales', () =>
    import(/* webpackChunkName: 'card-edc-sales-show' */ './show-card-edc-sales.vue'),
);

Vue.component('collected-report', () =>
    import(/* webpackChunkName: 'collected-report' */ './show-collected-report.vue'),
);

Vue.component('till-closure-list', () =>
    import(/* webpackChunkName: 'till-closure-list' */ './till-closure-list.vue'),
);

Vue.component('vuetable-till-list', () =>
    import(/* webpackChunkName: 'card-sales-show' */ './vuetable-till-list.vue'),
);

Vue.component('show-till-card-sales', () =>
    import(/* webpackChunkName: 'card-till-sales-show' */ './show-till-card-sales.vue'),
);

Vue.component('show-till-card-sales-old', () =>
    import(/* webpackChunkName: 'card-till-sales-show' */ './show-till-card-sales-old.vue'),
);

Vue.component('show-till-card-edc-sales', () =>
    import(/* webpackChunkName: 'card-till-edc-sales-show' */ './show-till-card-edc-sales.vue'),
);

Vue.component('inventory-final-posting-report', () =>
    import(/* webpackChunkName: 'inventory-final-posting-report' */ './inventory-final-posting-report.vue'),
);

if (Auth.metas().environment === 'shell') {
    Vue.component('fuel-end-shift-report', () =>
        import(/* webpackChunkName: 'fuel-end-shift-report' */ '../drawersession/shell-shift-report.vue'),
    );
} else if (Auth.metas().environment === 'bhp') {
    Vue.component('fuel-end-shift-report', () =>
        import(/* webpackChunkName: 'fuel-end-shift-report' */ '../drawersession/bhp-shift-report.vue'),
    );
} else if (Auth.metas().environment === 'ph') {
    Vue.component('fuel-end-shift-report', () =>
        import(/* webpackChunkName: 'fuel-end-shift-report' */ '../drawersession/phl-shift-report.vue'),
    );
} else {
    Vue.component('fuel-end-shift-report', () =>
        import(/* webpackChunkName: 'fuel-end-shift-report' */ '../drawersession/shift-report.vue'),
    );
}

if (Auth.metas().environment === 'shell') {
    Vue.component('till-summary-report', () =>
        import(/* webpackChunkName: 'till-summary-report' */ './shell-till-summary-report.vue'),
    );
} else if (Auth.metas().environment === 'bhp') {
    Vue.component('till-summary-report', () =>
        import(/* webpackChunkName: 'till-summary-report' */ './bhp-till-summary-report.vue'),
    );
} else if (Auth.metas().environment === 'ph') {
    Vue.component('till-summary-report', () =>
        import(/* webpackChunkName: 'till-summary-report' */ './phl-till-summary-report.vue'),
    );
} else {
    Vue.component('till-summary-report', () =>
        import(/* webpackChunkName: 'till-summary-report' */ './ronpos-till-summary-report.vue'),
    );
}



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/daily-sales/index.js